<template>
	<div class="hello_container">
		<div class="swiper_container">
			<el-carousel class="swiper_list" :interval="swiperSpeed" arrow="never">
				<el-carousel-item v-for="(item, index) in swiperList" :key="index">
					<div class="swiper_item">
						<div class="slogan-box">
							<span class="h6">{{ item.title }}</span>
							<span class="h1">{{ item.subTitle }}</span>
							<span class="h1">{{ item.thirdTitle }}</span>
							<div class="btn-box" v-if="isHideForTest">
								<button class="btn-1" @click="openDemoDialog(true)">
									{{ $t('index.btn_demo_show') }} <img src="@/assets/static/imgs/common/arrow-blue.png" alt="">
								</button>
								<button class="btn-2" @click="openFormDialog(true)">
									{{ $t('index.btn_scheme') }} <img src="@/assets/static/imgs/common/arrow-white.png" alt="">
								</button>
							</div>
						</div>

						<div class="banner-icon-around-box">
							<div class="around-box-pub around-box1">
								<ul class="line1">
									<li v-for="(item, index) in aroundIcons.line_1" :key="'line_1_' + index">
										<!-- <img v-lazy="item.icon" alt="ICON" /> -->
										<img :src="item.icon" alt="ICON" />
										<!-- <pre>{{ item }}</pre> -->
									</li>
								</ul>
							</div>

							<div class="around-box-pub around-box2">
								<ul class="line2">
									<li v-for="(item, index) in aroundIcons.line_2" :key="'line_2_' + index">
										<!-- <img v-lazy="item.icon" alt="ICON" /> -->
										<img :src="item.icon" alt="ICON" />
									</li>
								</ul>
							</div>

							<div class="around-box-pub around-box3">
								<ul class="line3">
									<li v-for="(item, index) in aroundIcons.line_3" :key="'line_3_' + index">
										<!-- <img v-lazy="item.icon" alt="ICON" /> -->
										<img :src="item.icon" alt="ICON" />
									</li>
								</ul>
							</div>
						</div>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>

		<!-- DEMO -->
		<DemoDialogPc />

		<!-- CONTACT FORM -->
		<el-dialog 
			:visible.sync="$store.state.isShowFormDialog" 
			:close-on-click-modal="false" 
			:close-on-press-escape="false" 
			custom-class="custom-dialog custom-dialog-contact-form">
			<div class="form-area">
				<div class="down-area infos">
					<div class="tel-area">
						<div class="postion">
							<img src="@/assets/static/imgs/common/icon-email.png" alt="">
							<span class="download">{{ $t('index.right_pop.contact_us_f') }}</span>
						</div>
						<div class="tel-account">
							<el-tooltip class="item" effect="dark" content="请将#替换为@" placement="top">
								<span>{{ $t('index.right_pop.contact_us_wx') }}</span>
							</el-tooltip>
						</div>
					</div>

					<div class="tel-area">
						<div class="postion">
							<img src="@/assets/static/imgs/common/icon-tel.png" alt="">
							<span class="download">{{ $t('index.right_pop.contact_us_tel_tips') }}</span>
						</div>
						<div class="tel-account rwft">
							<el-tooltip class="item" effect="dark" content="请将#替换为@" placement="top">
								<span>{{ $t('index.right_pop.contact_us_tel') }}</span>
							</el-tooltip>
						</div>
					</div>

					<div class="tel-area">
						<div class="postion">
							<img src="@/assets/static/imgs/common/icon-linkin.png" alt="">
							<span class="download">{{ $t('index.right_pop.contact_us_linkin_tips') }}</span>
						</div>
						<div class="tel-account rwft">
							<span>{{ $t('index.right_pop.contact_us_linkin') }}</span>
						</div>
					</div>
				</div>

				<div class="down-area-line-box">
					<div class="down-area-line"></div>
				</div>

				<div class="down-area el-form-wrapper">
					<el-form ref="form" :model="form" :rules="rules">
						<div>
							<el-form-item prop="name">
								<el-input 
									v-model="form.name" 
									:placeholder="$t('index.business_cooperation_form_placeholder_name')"></el-input>
							</el-form-item>

							<el-form-item prop="phone" class="phone-input-sty">
								<el-input 
									v-if="false" 
									v-model="form.phone" 
									:placeholder="$t('index.business_cooperation_form_placeholder_phone')"></el-input>
								<vue-phone-number-input 
									ref="phoneInput" 
									v-model="form.phone" 
									:default-country-code="countryCode" 
									@update="onUpdate" 
									id="midPhone" />
							</el-form-item>

							<el-form-item prop="company">
								<el-input 
									v-model="form.company" 
									:placeholder="$t('index.business_cooperation_form_placeholder_company')"></el-input>
							</el-form-item>

							<el-form-item prop="email">
								<el-input 
									v-model="form.email" 
									:placeholder="$t('index.business_cooperation_form_placeholder_email')"></el-input>
							</el-form-item>
	
							<el-button type="primary" @click="submitForm('form')">
								{{ $t('index.business_cooperation_form_button') }}
							</el-button>
						</div>
					</el-form>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
/**
 * Pc Components HelloWorld
 * @ is an alias to /src
 */
import { mapState }       from 'vuex';
import { postFormJoinUs } from '@/api/joinUsApi';
import formRules          from '@/utils/formRules';
import DemoDialogPc       from '@/components/pc/DemoDialog.vue';
import {
    DEMO_DIALOG_IS_SHOW,
    FORM_DIALOG_IS_SHOW
} from '@/type/mutation';
import { fetchAllGamesCached } from '@/api/gameDataLoader';

export default {
	name : 'HelloWorldPc',
	props: {
		msg: String
	},
	components: {
		DemoDialogPc
	},
	data() {
		return {
			swiperSpeed: 31536000000,
			swiperList : [
				{
					title     : 'Let Your Users Play Quality Games',
					subTitle  : 'HTML5',
					thirdTitle: '优质游戏提供商',
					/* subContents: [
						{
							url: 'https://cli.vuejs.org',
							tit: '0123456789'
						}
					], */
					/* bannerVideoOptions: {
						anis    : [
							bannerVideo1AniUp, 
							bannerVideo1AniDown
						],
						poster  : bannerVideo1Poster,
						src     : bannerVideo1Src,
						autoplay: true,
						loop    : true
					} */
				}
			],
			aroundIcons: {
                line_1: [], 
                line_2: [], 
                line_3: [] 
            },
			// About Phone
			results    : null,
			countryCode: 'CN',
			form       : {
				name       : '',
				countryCode: '',// 86
				phone      : '',// 132 1234 5678
				company    : '',
				email      : ''
			},
			rules: {
				name   : formRules.nameRules(this),
				phone  : formRules.phoneRules(this),
				company: formRules.companyRules(this),
				email  : formRules.emailRules(this)
			},
			allGames: []
		}
	},

	async mounted() {
    try {
        this.allGames = await fetchAllGamesCached();
    } catch (err) {
        console.error('=== HelloWorld__mounted__load failed >>>', err);
    }

		// 3) 使用 allGames 更新图标圈
		// console.log('=== HelloWorld__mounted__this.allGames >>>', this.allGames);
		// console.log('=== HelloWorld__mounted__this.allGames.length >>>', this.allGames.length);
		this.aroundIcons.line_1 = this.$Common.getRandomItemsFromArray(this.allGames, 12);
		this.aroundIcons.line_2 = this.$Common.getRandomItemsFromArray(this.allGames, 12);
		this.aroundIcons.line_3 = this.$Common.getRandomItemsFromArray(this.allGames, 12);
		// console.log('=== HelloWorld__mounted__this.aroundIcons.line_1 >>>', this.aroundIcons.line_1);

		// 4) 修改 vue-phone-number-input 插件的 placeholder 属性
		this.$nextTick(() => {
			const phoneInputRef = this.$refs.phoneInput;
			if(phoneInputRef && phoneInputRef.$el)
			{
				const phoneInputElement       = phoneInputRef.$el.querySelector('.input-phone-number input');
				phoneInputElement.placeholder = this.$t('index.business_cooperation_form_placeholder_phone');
				// console.log('phoneInputElement >>>', phoneInputElement);
			}
			else
			{
				console.warn('phoneInputRef 不存在');
			}
		});
	},

	methods: {
		openDemoDialog(value)
		{
			this.$store.commit(DEMO_DIALOG_IS_SHOW, value);
		},
		openFormDialog(value)
		{
			this.$store.commit(FORM_DIALOG_IS_SHOW, value);
		},
		closeFormDialog()
		{
			this.$store.commit(FORM_DIALOG_IS_SHOW, false);
		},

		// 获取电话信息的不同样式
		onUpdate(payload)
		{
			this.results = payload;
			// console.log('=== onUpdate__results >>>', this.results);

			// 让ERROR隐藏
			var botPhone = document.getElementById('midPhone');
			if(botPhone.nextElementSibling)
			{
				var nextElement = botPhone.nextElementSibling;
				nextElement.style.display = 'none';
			}

			this.$set(this.form, 'countryCode', this.results.countryCallingCode);// 86
			this.$set(this.form, 'phone', this.results.phoneNumber);             // 132 1234 5678
    	},

		// Submit Form
		async submitForm(formName)
		{
			this.$refs[formName].validate(async (valid) => {
				if(valid)
				{
					// Req
					/* console.log('=== submitForm__this__form >>>', this.form);
					return; */

					const res = await postFormJoinUs(this.form);
					// console.log('=== submitForm > res >>>', res);

					// 关闭输入弹窗
					// this.closeFormDialog();
					this.$refs.form.resetFields();
					
					if(res && res.errCode === 0)
					{
						this.$message({
							type       : 'success',
							customClass: 'zdyElMsg',
							message    : res.errMsg
						});
					}
					else if(res && res.errCode !== 0)
					{
						this.$message({
							type       : 'warning',
							customClass: 'zdyElMsg',
							message    : res.errMsg
						});
					}
					else
					{
						this.$message({
							type       : 'warning',
							customClass: 'zdyElMsg',
							message    : 'The operation failed. Please try again later~'
						});
					}
				}
				else
				{
					// console.log('=== this.form.phone >>>', this.form.phone);
					// console.log('=== this.form.valid >>>', valid);

					// 提交时：未输入手机号
					if(this.form.phone === null)
					{
						this.$message({
							type       : 'warning',
							customClass: 'zdyElMsg',
							message    : 'The operation failed. Please try again later~'
						});
					}
					else
					{
						// console.log('=== this.form.phone >>>', this.form.phone);
						const phoneNumberWithoutSpaces = this.form.phone.replace(/\s/g, '');// 移除所有空格
						const phoneNumberLength        = phoneNumberWithoutSpaces.length;
						if(phoneNumberLength < 5 || phoneNumberLength > 30)
						{
							this.$message({
								type       : 'warning',
								customClass: 'zdyElMsg',
								message    : 'Phone format error~'
							});
						}
					}
					
					console.log('=== ERROR SUBMIT <<<');
					return false;
				}
			});
		}
	},

	computed: {
		// ES6展开合并运算符 ['isShowDemoDialog', 'isShowFormDialog']
		...mapState([
			'isHideForTest'
		])
	}
}
</script>

<style lang="less" scoped>
/deep/ .custom-dialog-contact-form{
	width:640px;height:385px;
	border-radius:25px !important;
	.el-dialog__header{
		height:30px;
		padding:20px 20px 10px;
		.el-dialog__headerbtn{
			top:10px;right:20px;
			width:32px;height:32px;
			padding:5px;
			font-size:var(--com-base-fz-16);
		}
	}
	.el-dialog__body{
		height:355px;
		padding:0px 30px;
		.form-area{
			height:inherit;
			display:flex;justify-content:space-between;align-items:flex-start;
			/* gap:30px; */
			.down-area-line-box{
				width:1px;height:325px;
				display:flex;justify-content:center;align-items:center;
				.down-area-line{
					width:1px;height:300px;
					margin-top:0px;
					border-left:1px solid #ededed;
				}
			}
			.down-area{
				display:flex;flex-direction:column;justify-content:center;align-items:flex-start;
				gap:35px;
				.tel-area{
					padding-left:0;margin-top:unset;
					.postion{
						display:flex;justify-content:flex-start;align-items:center;
						img{
							width:24px;height:24px;
						}
						span{
							padding-left:5px;
							font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-18);color:var(--com-main-ft-color);font-style:normal;font-weight:bold;
						}
					}
					.tel-account{
						padding-left:30px;
						font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-17);color:#1D55FF;font-style:italic;font-weight:bold;
						span{
							font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-17);color:#1D55FF;font-style:italic;font-weight:bold;
						}
					}
					.rwft{
						color:#ADB2BC;/* font-style:normal;font-weight:normal; */
					}
				}
			}
			.el-form-wrapper{
				height:325px;
				.el-form{
					height:300px;
					div{
						display:flex;flex-direction:column;justify-content:space-between;align-items:center;
						.el-form-item{
							margin-bottom:0px !important;
							.el-form-item__content{
								.el-input{
									font-size:var(--com-base-fz-16);
									input.el-input__inner{
										width:266px;height:48px;line-height:1;
										margin-right:0px;padding:0 15px;
										border-radius:8px !important;
										border:1px solid #A4A2BD;
										background:#FAFBFC;
										transition:all .25s cubic-bezier(.645,.045,.355,1);
										&:focus{
											border-color:#409EFF;
											box-shadow:rgba(30, 144, 255,	0.7) 0px 0px 0px 2px;
										}
									}
									input.el-input__inner::placeholder{
										font-size:var(--com-base-fz-16);color:#C3C9D2;
									}
								}
								.el-form-item__error{
									padding-top:4px;
									font-size:var(--com-base-fz-12);
								}
							}
						}
						button{
							width:160px;height:42px;
							border-radius:21px;border:none;
							background:#1D55FF;
							span{
								font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-18);font-weight:normal;color:#FFF !important;
							}
						}
						.el-button{
							padding:12px 20px;
							font-size:var(--com-base-fz-18);
						}
					}
					.phone-input-sty, 
					.phone-input-sty .el-form-item__content,
					.vue-phone-number-input{
						flex-direction:row !important;
						.select-country-container{
							width:80px !important;min-width:80px;max-width:80px;
							margin-right:10px;
						}
						.country-selector{
							height:48px !important;
							.country-selector__label{display:none;}
							.country-selector__country-flag{
								display:none;
								top:25px;left:11px;
							}
							.country-selector__input{
								height:inherit;min-height:48px !important;
								border:1px solid #A4A2BD;
								border-top-left-radius:8px !important;
								border-top-right-radius:8px !important;
								border-bottom-right-radius:8px !important;
								border-bottom-left-radius:8px !important;
								/* border-right:none !important; */
								font-size:var(--com-base-fz-13);
								background:#FAFBFC;
								transition:all .25s cubic-bezier(.645,.045,.355,1);
							}
							&.has-value{
								.country-selector__label{
									font-size:var(--com-base-fz-11);
								}
								.country-selector__input{
									padding-top:unset !important;
									padding-left:18px !important;
								}
							}
						}
						.country-selector__label, .input-tel__label{
							display:none;
							top:-10px !important;left:11px !important;
							font-size:var(--com-base-fz-11);
						}
						.country-selector__list{
							left:0px;top:50px;
							width:266px !important;min-width:266px !important;
							height:217px !important;max-height:217px !important;
							border-radius:8px !important;
							background:#FAFBFC;
							padding-left:10px;
							.country-selector__list__item{
								width:266px !important;min-width:266px !important;
								background:transparent !important;
								div{
									align-items:flex-start;
								}
							}
						}			
						.input-tel{
							width:176px !important;height:48px !important;
							min-height:48px !important;
							.input-tel__input{
								height:inherit;min-height:48px !important;
								border:1px solid #A4A2BD;
								border-top-left-radius:8px !important;
								border-top-right-radius:8px !important;
    							border-bottom-right-radius:8px !important;
    							border-bottom-left-radius:8px !important;
								/* border-left:none !important; */
								font-size:var(--com-base-fz-16);
								background:#FAFBFC;
								padding-top:unset !important;
							}
							input.input-tel__input::placeholder{
								font-size:var(--com-base-fz-16);color:#C3C9D2;
							}
						}
						.country-selector__list__item__flag-container{
							display:none;
						}
					}
				}
				.el-form>div{
					height:300px;
				}
			}
			.infos{
				height:325px;
			}
		}
	}
}
.hello_container{
	position:relative;
	background:transparent;
	width:var(--com-base-container-w);height:var(--com-base-top-container-h2);
	.swiper_container{
		width:inherit;height:inherit;
		.swiper_list{
			width:inherit;height:inherit;
			/deep/ .el-carousel__container{
				width:var(--com-base-container-w);height:var(--com-base-top-container-h2);
				.el-carousel__item{
					height:inherit;
				}
			}
			/deep/ .el-carousel__indicators--horizontal{
				bottom:20px;left:0;transform:translateX(0%);
				button.el-carousel__button{
					display:none;
					opacity:.15;
					height:3px;
					border-radius:50px;
				}
				.is-active{
					button.el-carousel__button{
						display:none;
						opacity:1;
						background:linear-gradient(var(--gradient-direction), var(--gradient-color-start), var(--gradient-color-end));
					}
				}
			}
			.swiper_item{
				width:inherit;height:inherit;
				padding-top:260px;
				.slogan-box{
					padding-left:15px;
					span{display:block;}
					span.h6{margin:0;margin-bottom:15px;font-size:var(--com-base-fz-28);color:#FFF;font-style:italic;}
					span.h1{
						margin:0;font-size:var(--com-base-fz-60);color:#FFF;font-weight:bold;
						line-height:1;
					}
					.btn-box{
						display:flex;justify-content:flex-start;align-items:center;
						margin-top:75px;
						button{
							width:160px;height:50px;
							border-radius:25px;border:none;outline:none;
							font-size:var(--com-base-fz-18);text-align:center;font-weight:bold;
							cursor:pointer;
							img{
								width:18px;height:16px;
							}
						}
						button.btn-1{
							background:#FFF;color:#1D55FF;
							margin-right:15px;
						}
						button.btn-2{
							background:#1D55FF;color:#FFF;
						}
					}
				}
				.banner-icon-around-box{
					z-index:2;
					position:absolute;right:25px;bottom:180px;
					width:700px;height:500px;
					.around-box-pub{
						padding:0;
						transform-style:preserve-3d;
						perspective:1000px;perspective-origin:50% 50%;
					}
					.around-box1{margin:100px auto 0 auto;width:300px;height:88px;}
					.around-box2{margin:60px auto 0 auto;width:200px;height:83px;}
					.around-box3{margin:60px auto 0 auto;width:200px;height:83px;}
					ul{margin:0 auto;position:relative;transform-style:preserve-3d;}/* transform:rotateX(30deg); */
					ul.line1{animation:move 35s linear infinite;}
					ul.line2{animation:move 25s linear infinite;}
					ul.line3{animation:move 15s linear infinite;}
					ul li{position:absolute;top:0;left:0;overflow:hidden;transition:1s all ease;}
					ul.line1, ul.line1 li, ul.line1 li img{width:100px;height:100px;}
					ul.line2, ul.line2 li, ul.line2 li img{width:95px;height:95px;}
					ul.line3, ul.line3 li, ul.line3 li img{width:90px;height:90px;}
					
					ul.line1 li, 
					ul.line2 li, 
					ul.line3 li{border-radius:22px;}
					ul.line1 li, ul.line1 li img,
					ul.line2 li, ul.line2 li img{box-shadow:0 5px 40px 0 rgba(171, 89, 238, 0.6);}
					ul.line3 li, ul.line3 li img{box-shadow:0 5px 20px 0 rgba(171, 89, 238, 0.6);}

					/* ul li:hover img{width:120px;height:220px;} */
					ul.line1 li:nth-child(1) {transform:rotateY(30deg)  translateZ(270px);}
					ul.line1 li:nth-child(2) {transform:rotateY(60deg)  translateZ(270px);}
					ul.line1 li:nth-child(3) {transform:rotateY(90deg)  translateZ(270px);}
					ul.line1 li:nth-child(4) {transform:rotateY(120deg) translateZ(270px);}
					ul.line1 li:nth-child(5) {transform:rotateY(150deg) translateZ(270px);}
					ul.line1 li:nth-child(6) {transform:rotateY(180deg) translateZ(270px);}
					ul.line1 li:nth-child(7) {transform:rotateY(210deg) translateZ(270px);}
					ul.line1 li:nth-child(8) {transform:rotateY(240deg) translateZ(270px);}
					ul.line1 li:nth-child(9) {transform:rotateY(270deg) translateZ(270px);}
					ul.line1 li:nth-child(10){transform:rotateY(300deg) translateZ(270px);}
					ul.line1 li:nth-child(11){transform:rotateY(330deg) translateZ(270px);}
					ul.line1 li:nth-child(12){transform:rotateY(0deg)   translateZ(270px);}

					ul.line2 li:nth-child(1) {transform:rotateY(30deg)  translateZ(240px);}
					ul.line2 li:nth-child(2) {transform:rotateY(60deg)  translateZ(240px);}
					ul.line2 li:nth-child(3) {transform:rotateY(90deg)  translateZ(240px);}
					ul.line2 li:nth-child(4) {transform:rotateY(120deg) translateZ(240px);}
					ul.line2 li:nth-child(5) {transform:rotateY(150deg) translateZ(240px);}
					ul.line2 li:nth-child(6) {transform:rotateY(180deg) translateZ(240px);}
					ul.line2 li:nth-child(7) {transform:rotateY(210deg) translateZ(240px);}
					ul.line2 li:nth-child(8) {transform:rotateY(240deg) translateZ(240px);}
					ul.line2 li:nth-child(9) {transform:rotateY(270deg) translateZ(240px);}
					ul.line2 li:nth-child(10){transform:rotateY(300deg) translateZ(240px);}
					ul.line2 li:nth-child(11){transform:rotateY(330deg) translateZ(240px);}
					ul.line2 li:nth-child(12){transform:rotateY(0deg)   translateZ(240px);}

					ul.line3 li:nth-child(1) {transform:rotateY(30deg)  translateZ(210px);}
					ul.line3 li:nth-child(2) {transform:rotateY(60deg)  translateZ(210px);}
					ul.line3 li:nth-child(3) {transform:rotateY(90deg)  translateZ(210px);}
					ul.line3 li:nth-child(4) {transform:rotateY(120deg) translateZ(210px);}
					ul.line3 li:nth-child(5) {transform:rotateY(150deg) translateZ(210px);}
					ul.line3 li:nth-child(6) {transform:rotateY(180deg) translateZ(210px);}
					ul.line3 li:nth-child(7) {transform:rotateY(210deg) translateZ(210px);}
					ul.line3 li:nth-child(8) {transform:rotateY(240deg) translateZ(210px);}
					ul.line3 li:nth-child(9) {transform:rotateY(270deg) translateZ(210px);}
					ul.line3 li:nth-child(10){transform:rotateY(300deg) translateZ(210px);}
					ul.line3 li:nth-child(11){transform:rotateY(330deg) translateZ(210px);}
					ul.line3 li:nth-child(12){transform:rotateY(0deg)   translateZ(210px);}
				}
				.banner-bg-circle-box{
					z-index:1;
					position:absolute;right:65px;bottom:160px;
					width:320px;height:320px;
					animation:aniRotateRight 10s linear infinite;
					img{width:inherit;height:inherit;}
				}
				.banner-video-1-box{
					z-index:2;
					position:absolute;right:10px;bottom:50px;
					width:622px;height:358px;
					border:9px solid #fff;border-radius:27px;box-shadow:0 3px 18px 0 rgba(0,0,0,.1);
					cursor:pointer;
					video{width:100%;height:100%;border-radius:19px;}
				}
				.banner-video-ani-box{
					position:absolute;top:0;right:0;bottom:0;
					width:622px;height:var(--com-base-top-container-h1);
					.ani-up-c0{
						position:absolute;top:30px;right:53px;
						width:493px;height:247px;
						opacity:0;z-index:3;
						-webkit-animation:aniUp-c0 4s ease infinite;animation:aniUp-c0 4s ease infinite;
						pointer-events:none;
						img{width:inherit;height:inherit;}
					}
					.ani-down-c0{
						position:absolute;right:0;bottom:49px;
						width:660px;height:115px;
						opacity:0;z-index:3;
						-webkit-animation:aniDown-c0 4s ease infinite;animation:aniDown-c0 4s ease infinite;
						pointer-events:none;
						img{width:inherit;height:inherit;}
					}
				}
			}
		}
	}
}

@keyframes move{
    0%  {transform:rotateY(0deg);}
    10% {transform:rotateY(36deg);}
    20% {transform:rotateY(72deg);}
    30% {transform:rotateY(108deg);}
    40% {transform:rotateY(144deg);}
    50% {transform:rotateY(180deg);}
    60% {transform:rotateY(216deg);}
    70% {transform:rotateY(252deg);}
    80% {transform:rotateY(288deg);}
    90% {transform:rotateY(324deg);}
    100%{transform:rotateY(360deg);}
}
@keyframes aniRotateRight{
	0%{
		-webkit-transform:rotate(0deg);
		transform:rotate(0deg);
	}
	50%{
		-webkit-transform:rotate(180deg);
		transform:rotate(180deg);
	}
	100%{
		-webkit-transform:rotate(1turn);
		transform:rotate(1turn);
	}
}
@keyframes aniUp-c0{
	0%{
		top:30px;
		opacity:0;
	}
	50%{
		top:90px;
		opacity:1;
	}
	75%{
		top:90px;
		opacity:1;
	}
	100%{
		top:90px;
		opacity:0;
	}
}
@keyframes aniDown-c0{
	0%{
		bottom:-30px;
		opacity:0;
	}
	50%{
		bottom:-5px;
		opacity:1;
	}
	75%{
		bottom:-5px;
		opacity:1;
	}
	100%{
		bottom:-5px;
		opacity:0;
	}
}
</style>
